import { gql } from "apollo-boost";

export const STANDARD_MERGE = gql`
  mutation(
    $standardId: Int
    $setLibSetId: Int
    $rankId: Int
    $standardTime: String
    $effectiveDate: Date
    $comments: String
    $gender: String
    $facilityType: String
    $classification: String
    $updateSource: String
  ) {
    standardMerge(
      standardData: {
        standardId: $standardId
        setLibSetId: $setLibSetId
        rankId: $rankId
        standardTime: $standardTime
        effectiveDate: $effectiveDate
        comments: $comments
        gender: $gender
        facilityType: $facilityType
        classification: $classification
        updateSource: $updateSource
      }
    ) {
      node {
        standardId
        setLibSetId
        rankId
        standardTime
        effectiveDate
        comments
        gender
        facilityType
        classification
        updateDate
        updateSource
        id
      }
    }
  }
`;

export const STANDARD_DELETE = gql`
  mutation($standardId: Int!) {
    standardDelete(standardId: $standardId) {
      status
    }
  }
`;
